/* eslint-disable implicit-arrow-linebreak */
export const getCurrency = (value: number) =>
	new Intl.NumberFormat("uk-UA", {
		style: "currency",
		currency: "UAH",
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
		currencyDisplay: "narrowSymbol",
	}).format(value);
